import { RequestHandler } from 'express'
import axios, { AxiosResponse } from 'axios'

/** Response shape compatible with both axios and fetch clients */
export interface HttpResponseLike {
  data?: { errors?: unknown[] }
}

export function hasAxiosErrors(response: AxiosResponse | HttpResponseLike) {
  return response?.data?.errors?.length > 0
}

export function handleAsyncErrs(routeHandler: RequestHandler): RequestHandler {
  return async (req, res, next) => {
    try {
      await routeHandler(req, res, next)
    } catch (err) {
      next(err)
    }
  }
}

// Make Axios mockable
export const axiosHttp = axios.create()
